module.exports = __webpack_public_path__ + "img/locksmith.a387deda.png";